<template>
  <div :class="['item',index!=0&&index!=1?'item1':'']" @click="handleClickBtn(item)">
    <div class="top_img2">
      <img style="width:50px;height:21px" v-if="index==0" src="../../../static/image/NO2.png" alt="">
      <img style="width:50px;height:21px" v-if="index==1" src="../../../static/image/NO3.png" alt="">
    </div>
    <div class="top_img">
      <img style="width:100%;height:100%" src="https://xcd-prod.oss-cn-chengdu.aliyuncs.com/image/passhigh.png" alt="">
    </div>
    <div>
      <div class="tag">本产品由{{item.capitalName}}提供</div>
      <div class="title-container">
        <img v-show="item.capitalLogoList.length>0" :src="item.capitalLogoList[0]" alt />
        <h3 class="item-title">{{item.productName}}</h3>
      </div>
    </div>
    <ul>
      <li>
        <div class="count">{{item.quotaMax/10000}}</div>
        <h4 class="desc">最高额度（万元）</h4>
      </li>
      <li>
        <div class="count">
          {{item.loanRate}}
          <span class="percent">%</span>
        </div>
        <h4 class="desc">最低利率（年化）</h4>
      </li>
    </ul>
    <div class="bottom_box">
        <div class="bottom-tags">
          <div class="bottom-tag" v-for="(item, index) in item.productTags" :key="'tag'+index">{{item}}</div>
        </div>
        <div class="button-li">
        <van-button
          class="button button1"
          v-show="item.status==7 && item.productNature==0"
          type="info"
          size="small"
          @click.native.stop="handleClickBtn(item)"
        >查看详情</van-button>
        <van-button
          class="button"
          v-show="item.status==0 && item.productNature==0"
          type="info"
          size="small"
          @click.native.stop="shenheClickBtn"
        >审核中</van-button>
        <van-button
          class="button"
          v-show="item.status==6 && item.productNature==0"
          type="info"
          size="small"
          :disabled="true"
        >审核未通过</van-button>
        <van-button
          class="button"
          v-show="item.status==2 && item.productNature==0"
          type="info"
          size="small"
          @click.stop="goRecordDetail(item)"
        >用款</van-button>

        <van-button
          class="button button1"
          v-show="item.status==7 && item.productNature==1"
          type="info"
          size="small"
          @click.native.stop="handleClickBtn(item)"
        >立即申请</van-button>
        <van-button
          class="button"
          v-show="item.status==2 && item.productNature==1"
          type="info"
          size="small"
          @click.native.stop="handleClickBtns(item)"
        >用款</van-button>
        <van-button
          class="button"
          v-show="item.status==0 && item.productNature==1"
          type="info"
          size="small"
          @click.native.stop="handleClickBtns(item)"
        >办理中</van-button>
      </div>
    </div>
    <!-- <certification-options ref="popup"></certification-options> -->
    <certification-lb ref="popup"></certification-lb>
    <inputPopup ref="inputRef"
                v-model="bindShow"
                title="请填写推荐人姓名"
                leftTitle="跳过"
                rightTitle="确认"
                :activeIndex=2
                @leftChange="productClick(item)"
                @rightChange="bindUserClick">
    </inputPopup>
  </div>
</template>

<script>
import certificationOptions from "../popup/certificationOptions";
import router from "../../router/index";
import { Toast } from "vant"
import inputPopup from "../inputPopup/index";
import { referencePop } from "../../mixins/market/referencePop"
import {productClick} from "../../mixins/productClick/index"
export default {
  mixins: [referencePop, productClick],
  props: {
    item: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  name: "financingItem2",
  data() {
    return {
    };
  },
  components: {
    certificationOptions,
  },
  methods: {
    handleClickBtn(item) {
      this.userBind(item)
    },
    // productClick(itemObj) {
    //   localStorage.setItem("shisuanBack", window.location.href);
    //     this.$router.replace({
    //       path: "/financingDetail",
    //       query: { productNo: itemObj.productNo, status: itemObj.status, productNature: itemObj.productNature, loanLimit:itemObj.loanLimit },
    //     });
    // },
    shenheClickBtn: function () {
      localStorage.setItem("rzjlBack", window.location.href);
      this.$router.replace({ path: "/financingRecordsList" });
    },

    handleClickBtns(e) {
      let _this = this
      let dkId = localStorage.getItem("dkId");
        if (dkId) {
          this.$common.infoSubmit(
            "/app/auth/status",
            { dkId: localStorage.getItem("dkId") },
            (res) => {
              // console.log(res)
              if (res.status == 0) {
                //未认证
                localStorage.setItem('isFirst', '')
                localStorage.setItem("livingToPage", window.location.href);
                _this.$refs.popup.isPageShow = true;
              } else {
                //已认证
                // this.$common.pageEventHandle({eventType: 11, productNo: itemObj.productNo});
                // this.$common.pageEventHandle({eventType: 12, productNo: itemObj.productNo});
                if (e.status == 7) {
                  // _this.$common.getProjectUrl(e.productNo, "shenqing");
                  return
                } else {
                  // console.log(1)
                  let vo = {productNo:e.productNo,dkId:localStorage.getItem("dkId")}
                  _this.$common.getProjectUrl(vo, "yongkuan");
                }
                // this.$common.getData("/app/product/applyAgentProductAndUrl", {dkId:localStorage.getItem('dkId'),productNo:itemObj.productNo}, function (res) {
                //   // console.log(JSON.stringify(res));
                //   window.location.href=res;
                //   // window.open(res, "_blank");
                // });
              }
            }
          );
        }
    },

    // 本地产品申请成功跳转到记录详情
    goRecordDetail(item) {
      localStorage.setItem("yongkuan", window.location.href);
      this.$router.replace({
        path: '/financingRecordDetail',
        query: {capitalName: item.capitalName, loanLimit:item.loanLimit, productName: item.productName, creditStatusDesc: item.creditStatusDesc}
      })
    }
  },
};
</script>

<style lang="less" scoped>
.item {
  position: relative;
  margin: 15px 5px;
  padding: 15px 20px;
  background: linear-gradient(-20deg, #FFFFFF, #FFF4E5);
  box-shadow: 0px 10px 22px 0px rgba(33, 24, 21, 0.05);
  border-radius: 5px;
  padding-top: 25px;
  .top_img {
    position: absolute;
    top: 0;
    right: 0;
    height: 18px;
    width: 60px;
  }
  .top_img2 {
    position: absolute;
    top: -10px;
    left: 10px;
    // height: 18px;
    // width: 60px;
  }
  .tag {
    position: absolute;
    color: #C2B4A1;
    right: 13px;
    // top: 10px;
    font-size: 10px;
  }
  .title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
    margin-top: 10px;
  }
  .title-container img {
    display: inline-block;
    height: 20px;
    width: auto;
  }
  .item-title {
    font-size: 16px;
    height: 18px;
    line-height: 18px;
    font-weight: 600;
    color: rgba(24, 25, 24, 1);
    padding-right: 6px;
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .desc {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #8c8c8c;
  }
  .button-li {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    // position: absolute;
    // bottom: 15px;
    // right: 15px;
    .button {
      width: 78px;
      height: 30px;
      background: #2660ce;
      border-radius: 30px;
      font-size: 13px;
      line-height: 30px;
      font-weight: 400;
      color: #ffffff;
      border: none !important;
      // font-weight: bold;
    }
    .button1 {
      width: 78px;
      height: 30px;
      // background-color: #FDFAF5;
      background-color: #2660CE;
      border-radius: 30px;
      font-size: 13px;
      line-height: 30px;
      font-weight: 400;
      // color: #2660ce;
      color: #FFFFFF;
      box-sizing: border-box;
      // border: 1px solid #2660ce !important;
    }
  }
  ul {
    display: flex;
    width: 76%;
    align-items: center;
    li {
      flex: 1;
      text-align: left;
      .count {
        font-size: 22px;
        //font-weight: 400;
        // line-height: 30px;
        margin-bottom: 2px;
        color: #2660ce;
        font-family: DIN;
        font-weight: bold;
      }
      .percent {
        font-size: 12px;
      }
    }
  }
  .bottom-tags {
    .bottom-tag {
      border: 1px solid #B68F57;
      border-radius: 4px;
      padding: 0 4px;
      font-size: 10px;
      font-weight: 400;
      color: #B68F57;
      display: inline-block;
      margin-top: 10px;
      margin-right: 4px;
      margin-bottom: 3px;
    }
  }
}
.item1 {
  background: #ffffff;
}
.bottom_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/modules/financingItem2/index.vue